export default __webpack_public_path__ + "static/media/IMG_0018_1_11zon.b345e2fc.jpg";